/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-07-15T10:05:28.366
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listEnergyApplication,
	listEnergyApplicationInit,
	listEnergyApplicationByAuthorizations,
	deleteEnergyApplication,
	getEnergyApplicationInit
	
} from '@api/rentmanage/EnergyApplication';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery)
		// downloadRentTemplate:{}
	},
	mutations: {
	
	},
	actions: {
		listEnergyApplication({
			state
		}) {
			return new Promise((resolve, reject) => {
				listEnergyApplication(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listEnergyApplicationByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listEnergyApplicationByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listEnergyApplicationInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listEnergyApplicationInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteEnergyApplication({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteEnergyApplication({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		async getEnergyApplicationInit({commit}){
			let res = await getEnergyApplicationInit()
			return res
		}
	}
};
